import * as React from "react";
import * as CustomDescriptionBox from "../../../components/custom-description-box";
import styled, { css } from "styled-components";
import * as LoadGroup from "../load-group";
import { PropertyValueSet } from "@genesys/property";
import {
  getBackgroundsColor,
  getBorderColor
} from "../../../tools/error-severity-type-colors";
import { BorderRadius } from "@genesys/ui-elements";

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const ScrollContainer = styled.div`
  overflow-y: scroll;
  height: 58vh;
`;

const CardItem = styled.div`
  display: flex;
`;

const FlexRow = styled.div<{ readonly errorSeverity: LoadGroup.ErrorSeverity }>`
  ${props =>
    props.errorSeverity === "error" || props.errorSeverity === "warning"
      ? css`
          border: 2px solid ${getBorderColor(props.errorSeverity)};
          background-color: ${getBackgroundsColor(props.errorSeverity)};
          border-radius: ${BorderRadius.standard};
        `
      : ""}
  border-bottom: 2px solid ${props =>
    props.errorSeverity === "error" || props.errorSeverity === "warning"
      ? getBorderColor(props.errorSeverity)
      : "#d3d3d3"};
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
  margin-bottom: 1rem;

  padding-top: 5px;
  padding-left: 10px;
  padding-bottom: 1rem;
`;

const GroupContainer = styled.div`
  display: flex;
  align-items: center;
`;

const InfoText = styled.span`
  font-size: 13px;
`;

export function CardRow({
  items
}: {
  readonly items: ReadonlyArray<{
    readonly groupName: string;
    readonly infoText?: string;
    readonly item: React.ReactNode;
    readonly currentMoistureLoadSettings: PropertyValueSet.PropertyValueSet;
    readonly state: LoadGroup.State;
    readonly loadDef: LoadGroup.LoadDef;
  }>;
}) {
  return (
    <ScrollContainer>
      <Container>
        {items.map(
          ({
            groupName,
            item,
            infoText,
            state,
            loadDef,
            currentMoistureLoadSettings
          }) => (
            <FlexRow
              key={groupName}
              errorSeverity={LoadGroup.GetErrorSeverity(
                state,
                loadDef,
                currentMoistureLoadSettings
              )}
            >
              <GroupContainer>
                <CustomDescriptionBox.View title={groupName}>
                  <InfoText>{infoText}</InfoText>
                </CustomDescriptionBox.View>
                <h2>{groupName}</h2>
              </GroupContainer>
              <CardItem>{item}</CardItem>
            </FlexRow>
          )
        )}
      </Container>
    </ScrollContainer>
  );
}
